import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeeRosterLocaleModule: LocaleModule = {
  name: "employeeRoster",
  messages: { en: en, it: it },
};
